import { INDENT } from '@yme/tokens/sizes';
export const galleryConfig = {
    isControlsAvailable: true,
    hasPadding: true,
    isInLightbox: true,
    thumbnailsAmount: {
        desktop: 9,
        smallDesktop: 9,
        tablet: 6,
        mobile: 4,
    },
    thumbnailsIndent: {
        desktop: INDENT.xs,
        smallDesktop: INDENT.xs,
        tablet: INDENT.xs,
        mobile: INDENT.xs,
    },
};
